import { gql } from '@apollo/client';

export const GET_TRENDING_GLOBAL = gql`
  query getTrendingGlobal($limit: Int) {
    trendingStories(scope: GLOBAL, limit: $limit) {
      topic
      label
      storyCount
      topStoryId
    }
  }
`;
